import Marquee from "react-fast-marquee";

const LOGOS = [
  "MIDTRANS",
  "XENDIT",
  "DUITKU",
  "IPAYMU",
  "JNE",
  "J&T",
  "SICEPAT",
  "ANTERAJA",
  "NINJA XPRESS",
  "RAJAONGKIR",
  "POS INDONESIA",
];

export default function TrustBar({ t }) {
  return (
    <section
      className="py-10 md:py-14 border-y border-[var(--border)] bg-[#080808] relative overflow-hidden"
      data-testid="trust-bar"
    >
      <div className="container-x mb-6 flex items-center justify-center gap-3">
        <span className="w-6 h-[1px] bg-[var(--accent)]" />
        <p className="text-[10px] md:text-xs uppercase tracking-[0.3em] text-[var(--text-muted)] font-display text-center">
          {t.trust.label}
        </p>
        <span className="w-6 h-[1px] bg-[var(--accent)]" />
      </div>

      <Marquee gradient={false} speed={30} pauseOnHover>
        <div className="flex items-center gap-16 md:gap-24 pr-16 md:pr-24">
          {LOGOS.map((logo, i) => (
            <span
              key={i}
              className="font-display font-black text-2xl md:text-4xl tracking-tighter text-[var(--text-muted)] hover:text-[var(--text)] transition-colors duration-500 whitespace-nowrap"
            >
              {logo}
            </span>
          ))}
        </div>
      </Marquee>
    </section>
  );
}
